import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ProficiencyLevel } from '@app/competencies/models/proficiency-level';
import { RouteConstants } from '@app/shared/models/route-constants';
import { TenantSettings } from '@app/tenants/models/tenant-settings';
import { TenantsApiService } from '@app/tenants/services/tenants-api.service';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class TenantSettingsService {

	private _tenantSettings = new BehaviorSubject<TenantSettings>(null);
	public tenantSettings$ = this._tenantSettings.asObservable();

	public get tenantSettings (): TenantSettings {
		return this._tenantSettings.value;
	}
	public set tenantSettings (v: TenantSettings) {
		this._tenantSettings.next(v);
	}

	private _proficiencyLevels = new BehaviorSubject<ProficiencyLevel[]>(null);
	public proficiencyLevels$ = this._proficiencyLevels.asObservable();

	public proficiencyLevelsCount$ = this.proficiencyLevels$.pipe(
		map(levels => levels?.length ?? 0)
	);
	public get proficiencyLevels (): ProficiencyLevel[] {
		return this._proficiencyLevels.value;
	}
	public set proficiencyLevels (value: ProficiencyLevel[]) {
		this._proficiencyLevels.next(value);
	}

	constructor (
		private readonly tenantApiService: TenantsApiService,
		private router: Router
	) { }

	loadTenantSettings (): Observable<TenantSettings> {
		return this.tenantApiService.getTenantSettings().pipe(
			map(data => {
				this.tenantSettings = data.records;
				return this.tenantSettings;
			}),
			catchError(data => {
				if (data.status === 404) {
					this.router.navigate([RouteConstants.Error404]);
				}
				return throwError(() => data);
			})
		);
	}

	loadProficiencyLevels = (): Observable<ProficiencyLevel[]> => {
		return this.tenantApiService.getProficiencyLevels().pipe(
			map(data => data.records),
			tap(data => this.proficiencyLevels = data),
			catchError(data => {
				if (data.status === 404) {
					this.router.navigate([RouteConstants.Error404]);
				}
				return throwError(() => data);
			})
		);
	};
}